export default __webpack_public_path__ + "static/Boy-118819071e18635753a0248408935311.png";